<template>
  <index-page
    :aspect-menu-items="aspectMenuItems"
    :roles="roles"
    :permissions="permissions"
    :old-permissions="oldPermissions"
    :can-edit-admin="canEditAdmin"
    :errors="errors"
    :nav-items="aspectMenuItems"
    :resource-types="resourceTypes"
    :toasts="toasts"
  >
  </index-page>
</template>

<script>
import IndexPage from '@/structures/default/Pages/Settings/Access/Index';

export default {
  components: {
    IndexPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    resourceTypes: { type: Object, default: () => {} },
    roles: { type: Object, default: () => {} },
    permissions: { type: Object, default: () => {} },
    oldPermissions: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    canEditAdmin: { type: Boolean, default: false },
  },
  setup() {
    return {};
  },
};
</script>
